import { Injectable } from '@angular/core';

import { AxiosService } from './../../../core/axios';

import { UserSendCodeDTO, UserDTO, UserLoginDTO } from './../../dto/user.dto';
import { WorkShopDTO } from './../../dto/work-shop.dto';
import { CountryCmbDto } from './../../dto/country.dto';
import { StateDto, CityDto } from './../../dto/city.dto';
import { ResponseCodeDTO } from './../../../shared/dto/response-codes.dto';
import { VehicleTypeDTO } from '../../dto/vehicle-type.dto';
import { serviceCenterCategoryDTO } from '../../dto/service-center-category.dto';
import { serviceCenterCategoryServiceDTO } from '../../dto/service-center-category-services.dto';
import { serviceDTO } from '../../dto/serrvice.dto';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private readonly axiosService: AxiosService) {
    // do nothing
  }

  async getAvailableVehicleBrands(): Promise<any[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/utilities/getAvailableVehicleBrands');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getlistVehicleTypesAll(): Promise<VehicleTypeDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/utilities/listVehicleTypesAll');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableServiceCenterCategories(vehicleTypes: string): Promise<serviceCenterCategoryDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(`/utilities/getAvailableServiceCenterCategories?vehicleTypes=${vehicleTypes}`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableServiceCenterCategoryServicesByCategoryId(categoryId: string): Promise<serviceCenterCategoryServiceDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(`/utilities/getAvailableServiceCenterCategoryServicesByCategoryId?categoryId=${categoryId}`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableServiceCenterCategoryServicesSubServicesByServiceId(serviceId: string): Promise<serviceDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(
      `/utilities/getAvailableServiceCenterCategoryServicesSubServicesByServiceId?serviceId=${serviceId}`,
    );
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableServiceCenters(): Promise<WorkShopDTO[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/service-center');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableCountriesToCmb(): Promise<CountryCmbDto[]> {
    const result: ResponseCodeDTO = await this.axiosService.get('/utilities/findAvailableCountriesToCmb');
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableStatesByCountryCode(countryCoed: string): Promise<StateDto[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(`/utilities/findAvailableStatesByCountryCode?ctyCde=${countryCoed}`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getAvailableCityByStateCountryCode(countryCoed: string, stateCode: string): Promise<CityDto[]> {
    const result: ResponseCodeDTO = await this.axiosService.get(`/utilities/findAvailableCityByStateCountryCode?ctyCde=${countryCoed}&steCde=${stateCode}`);
    // console.log('getAvailableCityByStateCountryCode', result);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async getIPAddress(): Promise<string> {
    try {
      return new Promise((resolve) => {
        fetch('https://api.ipify.org?format=json')
          .then((response) => response.json())
          .then((data) => {
            resolve(data.ip);
          })
          .catch((error) => {
            console.log('EXCEPTION | getIPAddress - reject - ', error);
            resolve('');
          });
      });
    } catch (error: any) {
      console.error('EXCEPTION | getIPAddress - ', error);
      return '';
    }
  }

  async sendSmsCode(user: UserSendCodeDTO): Promise<ResponseCodeDTO> {
    try {
      return await this.axiosService.post('/auth/sendCodeValidate', user);
    } catch (error: any) {
      console.error('Error en sendSmsCode:', error);

      // Si el error está relacionado con Blob, proporcionar un mensaje más descriptivo
      if (error.toString && error.toString().includes('Blob')) {
        throw new Error('Error en el procesamiento del servidor. Por favor, contacta al soporte técnico.');
      }

      // Si es un error 500, proporcionar un mensaje más amigable
      if (error.response && error.response.status === 500) {
        throw new Error(
          'El servidor no pudo procesar la solicitud. Puede que el número de teléfono no esté registrado o el servicio esté temporalmente no disponible.',
        );
      }

      throw error;
    }
  }

  async validateSmsCode(user: UserSendCodeDTO): Promise<ResponseCodeDTO> {
    try {
      return await this.axiosService.post('/auth/codeValidate', user);
    } catch (error: any) {
      console.error('Error en validateSmsCode:', error);
      // Si el error está relacionado con Blob, proporcionar un mensaje más descriptivo
      if (error.toString && error.toString().includes('Blob')) {
        throw new Error('Error en el procesamiento del servidor. Por favor, contacta al soporte técnico.');
      }
      throw error;
    }
  }

  async registerUser(user: UserDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/register', user);
  }

  async login(user: UserLoginDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/login', user);
  }

  async requestPasswordReset(data: UserSendCodeDTO): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/request-password-reset', data);
  }

  async resetPassword(data: any): Promise<ResponseCodeDTO> {
    return await this.axiosService.post('/auth/reset-password', data);
  }
}
